import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface ImpersonatedUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role?: string;
}

interface ImpersonationStoreState {
  impersonatedUser: ImpersonatedUser | null;
  isImpersonating: boolean;
}

interface ImpersonationStoreActions {
  setImpersonatedUser: (user: ImpersonatedUser | null) => void;
  clearImpersonation: () => void;
}

export const useImpersonationStore = create<ImpersonationStoreState & ImpersonationStoreActions>()(
  persist(
    (set) => ({
      impersonatedUser: null,
      isImpersonating: false,

      setImpersonatedUser: (user) => {
        set({ 
          impersonatedUser: user, 
          isImpersonating: user !== null 
        });
      },

      clearImpersonation: () => {
        set({ 
          impersonatedUser: null, 
          isImpersonating: false 
        });
      },
    }),
    {
      name: 'tapkonnect-impersonation-storage',
    }
  )
);

// Helper hook to get the effective user ID (impersonated or real)
export const useEffectiveUserId = (realUserId: string | undefined): string | undefined => {
  const { impersonatedUser, isImpersonating } = useImpersonationStore();
  
  if (isImpersonating && impersonatedUser) {
    return impersonatedUser.id;
  }
  
  return realUserId;
};
